import { b2x } from '@b2x/react/src';
import classnames from 'classnames';

import { SocialsContentType } from './contentTypes';
import { t } from './i18n/i18n';
import { Icon, IconName, isIconName } from './Icon';

export interface SocialIconsProps {
  classNames?: string;
  size?: number;
}

export const SocialIcons = ({ classNames, size = 30 }: SocialIconsProps) => {
  const socialsContent = b2x.useContent<SocialsContentType>('SOCIALS_CONTENT');
  return (
    <div className={classnames('social-icons', classNames)}>
      <ul className="list-group list-group-horizontal list-unstyled gap-lg-2 gap-3">
        {socialsContent?.body.iconsList &&
          socialsContent.body.iconsList.map((item) => {
            return (
              item.name &&
              // item.url &&
              isIconName(item.name) && (
                <li key={item.iconTitle}>
                  {/* eslint-disable-next-line react/forbid-elements */}
                  <a
                    aria-label={t('accessibility.footer.socialIcon', { socialName: item.iconTitle })}
                    className="text-reset"
                    href={item.url}
                    rel="noreferrer"
                    target="_blank"
                  >
                    <Icon aria-hidden="true" className="icon-footer" fontSize={size} name={item.name as IconName} />
                  </a>
                </li>
              )
            );
          })}
      </ul>
    </div>
  );
};
